import FieldMediaPackages from './FieldMediaPackages.component';

export default FieldMediaPackages;
